import { formatarDataBr } from './tipos';

/**
 * Texto do intervalo de vigência ("dd/mm/aaaa — dd/mm/aaaa" ou "— atual"),
 * usado nas três abas (evita repetir a mesma formatação três vezes).
 */
interface VigenciaProps {
  vigenciaInicio: string;
  vigenciaFim: string | null;
}

export function TextoVigencia({ vigenciaInicio, vigenciaFim }: VigenciaProps) {
  return (
    <span className="text-sm">
      {formatarDataBr(vigenciaInicio)} — {vigenciaFim ? formatarDataBr(vigenciaFim) : 'atual'}
    </span>
  );
}
